export default {
    referent: [],
    next_url: null,
    total: 0,
}
